export default function Hero() {
  return (
    <>
      <section id="top" className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20background%20for%20a%20consumer%20watchdog%20and%20news%20portal%20site%2C%20deep%20vermilion%20red%20and%20amber%20gold%20textured%20paper%20with%20subtle%20ink%20brush%20strokes%20and%20abstract%20printed%20report%20layers%2C%20soft%20gradient%20dark%20space%20at%20center%20for%20text%20overlay%2C%20dramatic%20soft%20side%20lighting%2C%20premium%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=hero-99&orientation=landscape"
            alt="99黑料舆情观察与消费避坑资讯首屏背景"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 via-primary-900/60 to-accent-950/55" />
        </div>

        <div className="relative mx-auto flex w-full max-w-[1180px] flex-col items-center px-4 pt-36 pb-20 text-center md:px-6 md:pt-44 md:pb-24">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <i className="ri-radar-line" />
            企业 · 品牌 · 产品 · 服务 舆情观察
          </span>
          <h2 className="mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl">
            看清商业真相，<span className="text-accent-300">从核实一条信息开始</span>
          </h2>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-lg">
            99黑料持续追踪企业内幕、品牌争议与产品服务问题，汇集公司丑闻与翻车议题线索。
            我们坚持：只转述有公开信源的信息，标注核实状态，拒绝让“黑料”变成谣言。
          </p>

          <div className="mt-9 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row sm:gap-4">
            <a
              href="#topic"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto cursor-pointer"
            >
              浏览热点议题
              <i className="ri-arrow-right-line ml-2" />
            </a>
            <a
              href="#guide"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/50 bg-background-50/5 px-7 py-3.5 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/15 sm:w-auto cursor-pointer"
            >
              先看核实指南
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-xs text-background-100/85 md:text-sm">
            {[
              { icon: "ri-check-double-line", label: "信源可追溯" },
              { icon: "ri-time-line", label: "状态每日更新" },
              { icon: "ri-file-search-line", label: "无信源不发布" },
            ].map((f) => (
              <span key={f.label} className="inline-flex items-center gap-2">
                <i className={`${f.icon} text-accent-300`} />
                {f.label}
              </span>
            ))}
          </div>
        </div>
      </section>

      <div className="border-y border-accent-200 bg-accent-100/60">
        <div className="mx-auto flex w-full max-w-[1180px] flex-col items-center justify-between gap-3 px-4 py-4 text-center md:flex-row md:px-6 md:text-left">
          <p className="text-sm text-accent-900">
            <span className="font-bold">一条立场：</span>
            我们整理的是“有待求证的事实线索”，不是“给别人定罪的判决书”。
          </p>
          <a
            href="#about"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-bold text-accent-900 underline decoration-accent-400 underline-offset-4 hover:text-accent-800 cursor-pointer"
          >
            了解内容原则
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>
      </div>
    </>
  );
}